// Vanilla Canvas2D renderer for the "Sunflowers Rising" template.
// Sunflowers shoot up from the ground, bloom, and follow the sun.

function seededRandom(seed) {
  let t = seed + 0x6D2B79F5;
  return function () {
    t = (t + 0x6D2B79F5) | 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}

function hashId(id) {
  let h = 0;
  const s = String(id);
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return h >>> 0;
}

const SUNFLOWER_COLORS = [
  { petal: '#ffd700', center: '#8b4513', stem: '#2d5a1a', leaf: '#3a7020' },
  { petal: '#ffcc00', center: '#6b3a10', stem: '#3a6b20', leaf: '#457a28' },
  { petal: '#ffe066', center: '#7a4515', stem: '#2e5c1e', leaf: '#3d6b24' },
  { petal: '#fff0a0', center: '#5a3510', stem: '#357025', leaf: '#42802c' },
];

function drawSunflower(ctx, s, t, isHover) {
  const x = s.x;
  const y = s.y;
  const baseY = s.baseY;
  const progress = s.growthProgress;
  s._screenX = x;
  s._screenY = y;

  // Determine growth stages
  const sproutPhase = Math.min(1, progress / 0.3);
  const stemPhase = Math.min(1, Math.max(0, (progress - 0.3) / 0.4));
  const bloomPhase = Math.min(1, Math.max(0, (progress - 0.7) / 0.3));

  const maxHeight = s.maxHeight;
  const currentHeight = maxHeight * (sproutPhase * 0.3 + stemPhase * 0.5 + bloomPhase * 0.2);

  // Sunflowers stand upright - only a gentle wind sway moves them, no
  // permanent lean toward the sun.
  const leanAngle = 0;

  // Wind sway
  const windSway = Math.sin(t * 0.5 + s.windPhase) * 0.05 * stemPhase;

  // The stem is a curve, not a straight line - this returns the same x
  // offset the stem itself uses at a given height, so leaves and the
  // flower head can be anchored exactly onto that curve instead of
  // floating straight above the base.
  function stemXAt(h) {
    if (currentHeight <= 0) return 0;
    const frac = h / currentHeight;
    const segLean = (leanAngle + windSway) * frac;
    return Math.sin(segLean) * h;
  }

  // Stem segments for natural curve
  const segments = 12;
  ctx.save();
  ctx.translate(x, baseY);

  // Draw leaves
  if (stemPhase > 0.3) {
    const leafPairs = 3;
    for (let i = 0; i < leafPairs; i++) {
      const leafHeight = maxHeight * (0.25 + i / leafPairs * 0.5) * stemPhase;
      if (leafHeight > currentHeight) continue;
      const lean = leanAngle + windSway;
      const leafAngle = (i % 2 === 0 ? -1 : 1) * (Math.PI / 3 + Math.sin(t * 0.3 + i) * 0.2);

      ctx.save();
      ctx.translate(stemXAt(leafHeight), -leafHeight);
      ctx.rotate(lean);
      ctx.rotate(leafAngle);

      const leafLen = 30 + Math.sin(s.seed + i) * 15;
      const leafW = 12 + Math.sin(s.seed + i + 10) * 5;
      const leafGrad = ctx.createLinearGradient(0, 0, leafLen * Math.cos(leafAngle), leafLen * Math.sin(leafAngle));
      leafGrad.addColorStop(0, s.color.stem);
      leafGrad.addColorStop(0.5, s.color.leaf);
      leafGrad.addColorStop(1, '#1a3a0f');
      ctx.fillStyle = leafGrad;
      ctx.strokeStyle = '#1a3a0f';
      ctx.lineWidth = 1;

      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.bezierCurveTo(
        leafLen * 0.3, -leafW,
        leafLen * 0.7, -leafW * 0.5,
        leafLen, 0
      );
      ctx.bezierCurveTo(
        leafLen * 0.7, leafW * 0.5,
        leafLen * 0.3, leafW,
        0, 0
      );
      ctx.fill();
      ctx.stroke();
      ctx.restore();
    }
  }

  // Stem
  ctx.strokeStyle = s.color.stem;
  ctx.lineWidth = Math.max(2, 4 * progress);
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  ctx.beginPath();
  ctx.moveTo(0, 0);
  for (let i = 1; i <= segments; i++) {
    const segY = -currentHeight * i / segments;
    const segLean = (leanAngle + windSway) * i / segments;
    const segX = Math.sin(segLean) * currentHeight * i / segments;
    ctx.lineTo(segX, segY);
  }
  ctx.stroke();

  // Stem highlight
  ctx.strokeStyle = 'rgba(80, 140, 50, 0.4)';
  ctx.lineWidth = Math.max(1, 2 * progress);
  ctx.beginPath();
  ctx.moveTo(0, 0);
  for (let i = 1; i <= segments; i++) {
    const segY = -currentHeight * i / segments;
    const segLean = (leanAngle + windSway) * i / segments;
    const segX = Math.sin(segLean) * currentHeight * i / segments - 1;
    ctx.lineTo(segX, segY);
  }
  ctx.stroke();

  // Flower head
  if (bloomPhase > 0) {
    const headY = -currentHeight;
    const headSize = 25 + s.sizeVariation * 15;
    const petalCount = 18 + Math.floor(Math.sin(s.seed * 1.7) * 6);

    ctx.save();
    ctx.translate(stemXAt(currentHeight), headY);
    ctx.rotate(leanAngle + windSway * 0.5);

    // Petals - multiple layers for depth
    for (let layer = 0; layer < 3; layer++) {
      const layerScale = 1 - layer * 0.12;
      const layerPetals = petalCount - layer * 2;
      const petalLen = headSize * layerScale;
      const petalW = headSize * 0.35 * layerScale;
      const petalAngleOffset = layer * Math.PI / layerPetals * 0.5;

      for (let i = 0; i < layerPetals; i++) {
        const angle = (i / layerPetals) * Math.PI * 2 + petalAngleOffset;
        ctx.save();
        ctx.rotate(angle);

        const pgrad = ctx.createLinearGradient(0, 0, petalLen, 0);
        pgrad.addColorStop(0, s.color.petal);
        pgrad.addColorStop(0.4, '#ffe870');
        pgrad.addColorStop(1, '#ffd030');
        ctx.fillStyle = pgrad;
        ctx.strokeStyle = '#e8b810';
        ctx.lineWidth = 0.5;

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.bezierCurveTo(
          petalLen * 0.25, -petalW,
          petalLen * 0.65, -petalW * 0.3,
          petalLen, 0
        );
        ctx.bezierCurveTo(
          petalLen * 0.65, petalW * 0.3,
          petalLen * 0.25, petalW,
          0, 0
        );
        ctx.fill();
        ctx.stroke();
        ctx.restore();
      }
    }

    // Center (seeds) with Fibonacci spiral
    const centerR = headSize * 0.35 * bloomPhase;
    const seedCount = Math.floor(centerR * centerR * 0.15);
    for (let i = 0; i < seedCount; i++) {
      const phi = i * 2.399963; // Golden angle
      const r = centerR * Math.sqrt(i / seedCount) * bloomPhase;
      const angle = phi + t * 0.2;
      const sx = Math.cos(angle) * r;
      const sy = Math.sin(angle) * r;
      const sr = 1.5 + (i % 3) * 0.8;

      ctx.fillStyle = i % 4 < 2 ? '#4a2508' : '#8b4513';
      ctx.beginPath();
      ctx.arc(sx, sy, sr, 0, Math.PI * 2);
      ctx.fill();
    }

    // Center highlight
    const centerGrad = ctx.createRadialGradient(0, 0, 0, 0, 0, centerR);
    centerGrad.addColorStop(0, 'rgba(255,255,200,0.3)');
    centerGrad.addColorStop(1, 'rgba(200,180,100,0)');
    ctx.fillStyle = centerGrad;
    ctx.beginPath();
    ctx.arc(0, 0, centerR, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();
  }

  // Growth particles
  if (progress < 0.9 && s.rnd() > 0.98) {
    s.particles.push({
      x: x + (s.rnd() - 0.5) * 20,
      y: baseY - currentHeight + (s.rnd() - 0.5) * 30,
      vx: (s.rnd() - 0.5) * 0.5,
      vy: -1 - s.rnd() * 1.5,
      life: 1,
      color: s.rnd() > 0.5 ? '#ffeb3b' : '#a8e6cf',
    });
  }

  // Draw growth particles
  for (let i = s.particles.length - 1; i >= 0; i--) {
    const p = s.particles[i];
    p.x += p.vx;
    p.y += p.vy;
    p.vy += 0.02;
    p.life -= 0.015;
    if (p.life <= 0) { s.particles.splice(i, 1); continue; }
    ctx.globalAlpha = p.life * 0.8;
    ctx.fillStyle = p.color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, 3, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = 1;

  ctx.restore();

  // Hover glow
  if (isHover && bloomPhase > 0) {
    ctx.save();
    ctx.translate(x + stemXAt(currentHeight), baseY - currentHeight);
    ctx.rotate(leanAngle + windSway * 0.5);
    const headSize = 25 + s.sizeVariation * 15;
    ctx.beginPath();
    ctx.arc(0, 0, headSize * 1.5, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(255,255,255,0.6)';
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.restore();
  }
}

export function createSunflowersStage(canvas, opts = {}) {
  const ctx = canvas.getContext('2d');
  let width = 0;
  let height = 0;
  let dpr = Math.min(window.devicePixelRatio || 1, 2);
  const sunflowers = new Map();
  const grass = [];
  let hoverId = null;
  let selectCb = opts.onSelect || null;
  let hoverCb = opts.onHover || null;
  let running = true;
  let rafId = null;
  const startTime = performance.now();

  let bgImage = null;
  let bgImageReady = false;
  if (opts.backgroundImageUrl) {
    bgImage = new Image();
    bgImage.crossOrigin = 'anonymous';
    bgImage.onload = () => { bgImageReady = true; };
    bgImage.src = opts.backgroundImageUrl;
  }

  function drawCoverImage(img) {
    const scale = Math.max(width / img.width, height / img.height);
    const w = img.width * scale;
    const h = img.height * scale;
    ctx.drawImage(img, (width - w) / 2, (height - h) / 2, w, h);
  }

  function resize() {
    const rect = canvas.parentElement.getBoundingClientRect();
    width = Math.max(1, rect.width);
    height = Math.max(1, rect.height);
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    if (grass.length === 0) {
      const rnd = seededRandom(200);
      for (let i = 0; i < 200; i++) {
        grass.push({
          x: rnd(),
          baseY: 0.85 + rnd() * 0.15,
          height: 15 + rnd() * 30,
          width: 1.5 + rnd() * 2.5,
          color: rnd() > 0.5 ? '#2d5a1a' : '#3a7020',
          sway: rnd() * Math.PI * 2,
          speed: 0.3 + rnd() * 0.5,
        });
      }
    }
    layoutSunflowers();
  }

  function layoutSunflowers() {
    for (const s of sunflowers.values()) {
      if (s.laidOut) continue;
      const marginX = 60;
      const marginY = 100;
      s.x = marginX + s.rnd() * Math.max(1, width - marginX * 2);
      s.baseY = height - marginY;
      s.sunX = width * 0.8;
      s.sunY = height * 0.15;
      s.maxHeight = height * (0.5 + s.rnd() * 0.3);
      s.sizeVariation = s.rnd();
      s.windPhase = s.rnd() * Math.PI * 2;
      s.particles = [];
      s.laidOut = true;
    }
  }

  function ensureSunflower(msg) {
    if (sunflowers.has(msg.id)) return;
    const seed = hashId(msg.id);
    const rnd = seededRandom(seed);
    const color = SUNFLOWER_COLORS[seed % SUNFLOWER_COLORS.length];
    sunflowers.set(msg.id, {
      id: msg.id,
      sender_name: msg.sender_name,
      message_body: msg.message_body,
      rnd,
      color,
      seed,
      growthProgress: 0,
      laidOut: false,
      x: width / 2,
      baseY: height,
      sunX: width * 0.8,
      sunY: height * 0.15,
      maxHeight: 300,
      sizeVariation: 0.5,
      windPhase: 0,
      particles: [],
    });
  }

  function setMessages(messages) {
    for (const msg of messages) ensureSunflower(msg);
    layoutSunflowers();
  }

  function drawBackground(t) {
    if (bgImageReady) {
      drawCoverImage(bgImage);
      return;
    }

    // Sky
    const skyGrad = ctx.createLinearGradient(0, 0, 0, height);
    skyGrad.addColorStop(0, '#70c0e8');
    skyGrad.addColorStop(0.4, '#98d0f0');
    skyGrad.addColorStop(0.7, '#b8e0f8');
    skyGrad.addColorStop(1, '#d8f0fc');
    ctx.fillStyle = skyGrad;
    ctx.fillRect(0, 0, width, height);

    // Sun
    const sunX = width * 0.8;
    const sunY = height * 0.15;
    const sunR = Math.min(width, height) * 0.08;
    const sunGrad = ctx.createRadialGradient(sunX, sunY, 0, sunX, sunY, sunR * 4);
    sunGrad.addColorStop(0, 'rgba(255,255,200,0.5)');
    sunGrad.addColorStop(0.5, 'rgba(255,240,180,0.2)');
    sunGrad.addColorStop(1, 'rgba(255,230,150,0)');
    ctx.fillStyle = sunGrad;
    ctx.fillRect(sunX - sunR * 4, sunY - sunR * 4, sunR * 8, sunR * 8);
    ctx.beginPath();
    ctx.arc(sunX, sunY, sunR, 0, Math.PI * 2);
    ctx.fillStyle = '#fffef0';
    ctx.fill();

    // Rolling plains: several wavy, layered hill bands instead of a flat
    // gradient rectangle, so the ground reads as real contoured terrain.
    const groundTop = height * 0.68;
    const bandColors = ['#4d7d36', '#43722e', '#396526', '#2d5820', '#21481a'];
    const bandCount = bandColors.length;
    for (let b = 0; b < bandCount; b++) {
      const bandT = b / (bandCount - 1);
      const yBase = groundTop + (height - groundTop) * (0.08 + bandT * 0.75);
      const amplitude = (6 + b * 3) * (height / 500);
      const freq = 0.006 + b * 0.0025;
      const phase = b * 1.9;
      ctx.beginPath();
      ctx.moveTo(0, height);
      ctx.lineTo(0, yBase);
      for (let x = 0; x <= width; x += 16) {
        const y = yBase + Math.sin(x * freq + phase) * amplitude + Math.sin(x * freq * 2.3 + phase) * amplitude * 0.3;
        ctx.lineTo(x, y);
      }
      ctx.lineTo(width, height);
      ctx.closePath();
      ctx.fillStyle = bandColors[b];
      ctx.fill();
    }

    // Grass
    for (const g of grass) {
      const gx = g.x * width;
      const gy = g.baseY * height;
      const gh = g.height;
      const gw = g.width;
      const sway = Math.sin(t * g.speed + g.sway) * 5;
      ctx.strokeStyle = g.color;
      ctx.lineWidth = gw;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(gx, gy);
      ctx.quadraticCurveTo(gx + sway, gy - gh * 0.5, gx + sway * 0.5, gy - gh);
      ctx.stroke();
    }
  }

  function frame(now) {
    if (!running) return;
    const t = (now - startTime) / 1000;
    drawBackground(t);

    // Update growth progress
    for (const s of sunflowers.values()) {
      if (s.growthProgress < 1) {
        s.growthProgress = Math.min(1, s.growthProgress + 0.003);
      }
    }

    for (const s of sunflowers.values()) {
      drawSunflower(ctx, s, t, s.id === hoverId);
    }
    rafId = requestAnimationFrame(frame);
  }

  function hitTest(clientX, clientY) {
    const rect = canvas.getBoundingClientRect();
    const px = clientX - rect.left;
    const py = clientY - rect.top;
    let found = null;
    let bestDist = Infinity;
    for (const s of sunflowers.values()) {
      const currentHeight = s.maxHeight * Math.min(1, s.growthProgress);
      const sx = s.x;
      const sy = s.baseY - currentHeight;
      const dx = sx - px;
      const dy = sy - py;
      const dist = Math.hypot(dx, dy);
      const hitR = Math.max(30, 40 * s.growthProgress);
      if (dist <= hitR && dist < bestDist) {
        bestDist = dist;
        found = s;
      }
    }
    return found ? { obj: found, x: px, y: py } : null;
  }

  function handleMove(e) {
    const hit = hitTest(e.clientX, e.clientY);
    const id = hit ? hit.obj.id : null;
    if (id !== hoverId) {
      hoverId = id;
      canvas.style.cursor = id ? 'pointer' : 'default';
      if (hoverCb) hoverCb(hit ? { id: hit.obj.id, sender_name: hit.obj.sender_name, message_body: hit.obj.message_body, x: hit.x, y: hit.y } : null);
    } else if (hit && hoverCb) {
      hoverCb({ id: hit.obj.id, sender_name: hit.obj.sender_name, message_body: hit.obj.message_body, x: hit.x, y: hit.y });
    }
  }

  function handleClick(e) {
    const hit = hitTest(e.clientX, e.clientY);
    if (hit && selectCb) {
      selectCb({ id: hit.obj.id, sender_name: hit.obj.sender_name, message_body: hit.obj.message_body }, { x: hit.x, y: hit.y });
    }
  }

  function handleLeave() {
    if (hoverId !== null) {
      hoverId = null;
      canvas.style.cursor = 'default';
      if (hoverCb) hoverCb(null);
    }
  }

  canvas.addEventListener('pointermove', handleMove);
  canvas.addEventListener('click', handleClick);
  canvas.addEventListener('pointerleave', handleLeave);

  resize();
  rafId = requestAnimationFrame(frame);

  return {
    setMessages,
    onSelect(cb) { selectCb = cb; },
    onHover(cb) { hoverCb = cb; },
    resize,
    destroy() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      canvas.removeEventListener('pointermove', handleMove);
      canvas.removeEventListener('click', handleClick);
      canvas.removeEventListener('pointerleave', handleLeave);
    },
  };
}